module.exports = __webpack_public_path__ + "img/marq01-2.1c38d13a.jpg";